import { render, staticRenderFns } from "./GateManage.vue?vue&type=template&id=b7f64616&scoped=true&"
import script from "./GateManage.vue?vue&type=script&lang=js&"
export * from "./GateManage.vue?vue&type=script&lang=js&"
import style0 from "./GateManage.vue?vue&type=style&index=0&id=b7f64616&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f64616",
  null
  
)

export default component.exports